import { useEffect, useState } from 'react';
import { recuperaPuestosPorUsuario } from '../../services/Siniestro/SiniestroService';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

import UbicacionMapaII from './UbicacionMapaII';
import GeointSorisegHeader from './GeointSorisegHeader';
import DialogoMisRutas from './DialogoMisRutas';

const UbicacionSiniestro = () => {
    const [lstPuestos, setLstPuestos] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [mostrarRutas, setMostrarRutas] = useState(false);
    const [versionRutas, setVersionRutas] = useState(0);

    useEffect(() => {
        const recuperaPuestos = async () => {
            try {
                setCargando(true);
                const datos = await recuperaPuestosPorUsuario();
                //console.log('PUESTOS DEL USUARIO', datos);
                setLstPuestos(datos);
            } catch (error) {
                console.error('ERROR: recuperando Puestos de Usuario');
            } finally {
                setCargando(false);
            }
        };
        recuperaPuestos();
    }, []);

    return (
        <div className="surface-card p-4 shadow-3 border-round-xl">
            <GeointSorisegHeader subtitle="Ubicación de Eventos Delictivos y Operativos de Seguridad" />
            {cargando ? (
                <div className="flex flex-column justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                    <ProgressSpinner style={{ width: '50px', height: '50px' }} animationDuration="1s" />
                    <p className="text-600 mt-3">Cargando puestos del usuario...</p>
                </div>
            ) : lstPuestos.length === 0 ? (
                <Card className="flex flex-column align-items-center justify-content-center textAlign-center p-5 shadow-1 border-1 surface-border">
                    <i className="pi pi-users text-400 mb-3" style={{ fontSize: '3rem' }}></i>
                    <h3 className="text-900 m-0 font-medium">Sin puestos asignados</h3>
                    <p className="text-600 mt-2">El usuario no tiene puestos asignados en el sistema.</p>
                </Card>
            ) : (
                <>
                    <div className="flex justify-content-end mb-3">
                        <Button
                            label="Mis Rutas"
                            icon="pi pi-directions"
                            className="p-button-outlined p-button-info"
                            onClick={() => setMostrarRutas(true)}
                            tooltip="Crear y administrar rutas guardadas para filtrar eventos cercanos"
                        />
                    </div>
                    <DialogoMisRutas
                        visible={mostrarRutas}
                        onHide={() => setMostrarRutas(false)}
                        onCambios={() => setVersionRutas((v) => v + 1)}
                    />
                    <UbicacionMapaII listaPuestos={lstPuestos} versionRutasGuardadas={versionRutas} />
                </>
            )}
        </div>
    );
};

export default UbicacionSiniestro;
